import { render, staticRenderFns } from "./NMenuModal.vue?vue&type=template&id=0015afa6&scoped=true"
import script from "./NMenuModal.vue?vue&type=script&lang=js"
export * from "./NMenuModal.vue?vue&type=script&lang=js"
import style0 from "./NMenuModal.vue?vue&type=style&index=0&id=0015afa6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0015afa6",
  null
  
)

export default component.exports